module.exports = {
    "postbox-text": "コメントを入力してください (3文字以上)",
    "postbox-author": "名前 (任意)",
    "postbox-author-placeholder": "John Doe",
    "postbox-email": "E-mail (任意)",
    "postbox-email-placeholder": "johndoe@example.com",
    "postbox-website": "ウェブサイト (任意)",
    "postbox-website-placeholder": "https://example.com",
    "postbox-preview": "プレビュー",
    "postbox-edit": "編集",
    "postbox-submit": "送信",
    "postbox-notification": "返信があった場合にメールで通知する",

    "num-comments": "コメント 1件\nコメント {{ n }}件",
    "no-comments": "まだコメントはありません",
    "atom-feed": "Atomフィード",

    "comment-reply": "返信",
    "comment-edit": "編集",
    "comment-save": "保存",
    "comment-delete": "削除",
    "comment-confirm": "確認",
    "comment-close": "閉じる",
    "comment-cancel": "キャンセル",
    "comment-deleted": "コメントは削除されました",
    "comment-queued": "コメントは承認待ちです",
    "comment-anonymous": "名無し",
    "comment-hidden": "{{ n }}件 非表示",
    "comment-page-author-suffix": "管理人",

    "date-now": "たった今",
    "date-minute": "1分前\n{{ n }}分前",
    "date-hour": "1時間前\n{{ n }}時間前",
    "date-day": "昨日\n{{ n }}日前",
    "date-week": "先週\n{{ n }}週間前",
    "date-month": "先月\n{{ n }}ヶ月前",
    "date-year": "1年前\n{{ n }}年前"
};
